<style>
    .mtapp-add-row-button {
        top: 0.5rem;
    }
</style>

<script>
    import { createEventDispatcher } from 'svelte';
    import MultiFieldInput from './MultiFieldInput.svelte';
    import MultiFieldAsset from './MultiFieldAsset.svelte';
    import { deepCopy } from '../../../deepCopy.js';
    import { modalConfirm } from '../../../modalConfirm.js';
    import { temporaryId } from '../../../temporaryId.js';

    export let mtappVars;
    export let id;
    export let item;

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }

    /**
     * 行を上に移動する。
     * @param {number} rowIdx
     */
    function rowUp(rowIdx) {
        [item.data[rowIdx - 1], item.data[rowIdx]] = [item.data[rowIdx], item.data[rowIdx - 1]];
        item.data = item.data;
        triggerInputChange();
    }

    /**
     * 行を下に移動する。
     * @param {number} rowIdx
     */
    function rowDown(rowIdx) {
        [item.data[rowIdx], item.data[rowIdx + 1]] = [item.data[rowIdx + 1], item.data[rowIdx]];
        item.data = item.data;
        triggerInputChange();
    }

    /**
     * 行を削除する。
     * @param {number} rowIdx
     */
    function rowRemove(rowIdx) {
        modalConfirm({
            type: 'warning',
            title: '確認',
            content: '行を削除しますか？',
            okButtonLabel: '削除',
            cancelButtonLabel: 'キャンセル',
            callback: function () {
                item.data.splice(rowIdx, 1);
                triggerInputChange();
            }
        });
    }

    /**
     * 行を追加する。
     */
    function rowAdd() {
        const row = deepCopy(item.options);
        row.forEach((option, index) => {
            row[index].id = temporaryId();
        });
        item.data.push(row);
        triggerInputChange();
    }
</script>

<div data-handle={item.type}>
    <div class="mt-table--outline">
        <table id={id} class="table mt-table">
            <thead>
                <tr>
                    {#each item.options as option}
                        <th scope="col">{option.label}</th>
                    {/each}
                    <th scope="col">&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                {#each item.data as row, rowIdx (id + rowIdx)}
                    <tr>
                        {#each row as cell, cellIdx (id + rowIdx + cellIdx)}
                            <td class="p-2">
                                {#if ['text', 'email', 'url', 'tel', 'password', 'number', 'datepicker', 'date', 'time', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'textarea', 'code', 'tinymce', 'select', 'select-multiple', 'checkbox', 'radio'].includes(cell.type)}
                                    <MultiFieldInput mtappVars={mtappVars} item={cell} on:inputchange={triggerInputChange} />
                                {:else if ['asset', 'image'].includes(cell.type)}
                                    <MultiFieldAsset mtappVars={mtappVars} id={cell.id} item={cell} on:inputchange={triggerInputChange} />
                                {/if}
                            </td>
                        {/each}
                        <td class="p-2">
                            <div class="btn-group btn-group-sm" role="group">
                                <button
                                    class="btn btn-default p-1"
                                    type="button"
                                    tabindex="-1"
                                    disabled={rowIdx === 0}
                                    on:click={() => rowUp(rowIdx)}
                                    aria-label="Move Up">
                                    <svg role="img" class="mt-icon mr-0 top-0">
                                        <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_tri-up'} />
                                    </svg>
                                </button>
                                <button
                                    class="btn btn-default p-1"
                                    type="button"
                                    tabindex="-1"
                                    disabled={Array.isArray(item.data) && rowIdx === item.data.length - 1}
                                    on:click={() => rowDown(rowIdx)}
                                    aria-label="Move Down">
                                    <svg role="img" class="mt-icon mr-0 top-0">
                                        <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_tri-down'} />
                                    </svg>
                                </button>
                                <button
                                    class="btn btn-default p-1"
                                    type="button"
                                    tabindex="-1"
                                    disabled={item.data.length <= 1}
                                    on:click={() => rowRemove(rowIdx)}
                                    aria-label="Remove">
                                    <svg role="img" class="mt-icon mr-0 top-0">
                                        <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_trash'} />
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    {#if item.add !== false}
        <p class="position-relative d-flex flex-row-reverse mtapp-add-row-button">
            <button class="btn btn-default mt-3 d-flex align-items-center" type="button" on:click={rowAdd}>
                <svg role="img" class="mt-icon">
                    <use xlink:href={mtappVars.static_path + '/images/sprite.svg#ic_add'} />
                </svg>
                {mtappVars.translate['Add a row']}
            </button>
        </p>
    {/if}
</div>
